export default "__VITE_ASSET__C5bID6Gw__"